<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>消息管理</p>
    </div>
    <div class="panel-content">
      <form
        id="searchSection"
        onSubmit="return false;"
      >
        <input
          type="text"
          placeholder="消息主题"
          class="s-input separate"
          v-model="queryInfo.title"
        >
        <select
          class="s-select separate"
          v-model="queryInfo.status"
        >
          <option value="">操作状态</option>
          <option value="0">未发送</option>
          <option value="1">发送</option>
        </select>

        <input
          type="button"
          class="s-btn"
          value="搜索"
          @click="pageCallback(1)"
        >
        <div
          class="add-btn"
          @click="showEditWindow('add')"
        >新建</div>
      </form>
      <div id="list">
        <table v-if="tableData.length">
          <tr class="l_header">
            <th>消息主题</th>
            <th>创建人</th>
            <th>创建时间</th>
            <th>发送时间</th>
            <th>状态</th>
            <th
              class="action"
              width="180"
            >操作</th>
          </tr>
          <tr
            class="item"
            v-for="(item,index) in tableData"
            :key="index"
          >
            <td>{{item.title}}</td>
            <td>{{item.creator.name}}</td>
            <td>{{formatTime(item.created)}}</td>
            <td>{{item.sendTime?item.sendTime.replace('T',' '):'--'}}</td>
            <td>{{item.status?'已发送':'未发送'}}</td>
            <td class="action">
              <a
                v-if="item.status==0"
                class="edit"
                href="javascript:;"
                @click="querySingle(item.id)"
              >维护</a>
              <a
                v-if="item.status==1"
                class="send"
                href="javascript:;"
              >已发送</a>
              <a
                v-if="item.status==0"
                class="publish"
                href="javascript:;"
                @click="publish(item.id)"
              >发送</a>
              <a
                class="delete"
                href="javascript:;"
                @click="askDelete(item.id)"
              >删除</a>
            </td>
          </tr>
        </table>
        <div
          class="noitems"
          v-else
        >没有数据</div>
      </div>
      <!-- 分页 -->
      <pagination
        :cur='pageInfo.page'
        :all='pageInfo.all'
        :totalData="pageInfo.totalData"
        :callback="pageCallback"
      ></pagination>
    </div>
    <div
      class="form_overlay"
      id="form_overlay"
      :style="classShowEditWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">添加/编辑</div>
        <div class="form_content">
          <form id="itemForm">
            <div class="item">
              <span class="label"><i class="require">*</i>标题:</span>
              <input
                type="text"
                v-model="formInfo.title"
                maxlength="25"
              >
            </div>
            <div class="item">
              <span class="label"><i class="require">*</i>内容:</span>
              <textarea
                id=""
                v-model="formInfo.content"
                placeholder="请输入你要发送的内容（200字以内）"
                maxlength="200"
              ></textarea>
            </div>

            <div class="clearfix"></div>
          </form>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button close"
            id="form_close"
            @click="hideEditWindow"
          >取消</a>
          <a
            href="javascript:;"
            class="button"
            id="form_submit"
            @click="saveInfo"
          >提交</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '../../../components/Pager'
export default {
  name: 'Feedback',
  components: {
    Pagination
  },
  data() {
    return {
      classShowEditWindow: {},
      queryInfo: {
        page: 1,
        size: 10,
        title: '',
        status: ''
      },
      tableData: [],
      tableDataCount: 0,
      formInfo: {
        id: 0,
        title: '',
        content: ''
      }
    }
  },
  // 计算属性
  computed: {
    pageInfo() {
      return {
        page: this.queryInfo.page,
        all: Math.ceil(this.tableDataCount / this.queryInfo.size),
        totalData: this.tableDataCount
      }
    }
  },
  methods: {
    formatTime(val) {
      return val.replace('T', ' ').substring(0, val.indexOf('.'))
    },
    async search() {
      await this.$http.get('/message/', {
        params: this.queryInfo
      }).then((data) => {
        this.tableData = data.results
        this.tableDataCount = data.count
      }).catch((error) => {
        console.log(error)
      })
    },
    showEditWindow(value) {
      if (value === 'add') {
        this.formInfo = {
          id: 0,
          title: '',
          content: ''
        }
      }

      this.classShowEditWindow = { visibility: 'visible' }
    },
    hideEditWindow() {
      this.classShowEditWindow = { visibility: 'hidden' }
    },
    // 编辑时查询
    async querySingle(id) {
      const url = '/message/' + id + '/'
      await this.$http.get(url).then((data) => {
        this.formInfo.id = data.id
        this.formInfo.title = data.title
        this.formInfo.content = data.content
        this.showEditWindow('edit')
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('数据获取失败！')
      })
    },
    // 提交信息
    async saveInfo() {
      if (!this.formInfo.title) {
        this.$layer.msg('请输入标题!')
        return false
      }
      if (!this.formInfo.content) {
        this.$layer.msg('请输入内容!')
        return false
      }

      if (this.formInfo.id) {
        const url = '/message/' + this.formInfo.id + '/'
        await this.$http.put(url, {
          title: this.formInfo.title,
          content: this.formInfo.content
        }).then((data) => {
          if (data.id) {
            this.$layer.msg('修改成功！')
            this.hideEditWindow()
            this.search()
          } else {
            this.$parent.$parent.showMsg('修改失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('修改失败！')
        })
      } else {
        await this.$http.post('/message/', {
          id: this.formInfo.id,
          title: this.formInfo.title,
          content: this.formInfo.content,
          creator_id: this.$store.state.userInfo.profile_id
        }).then((data) => {
          if (data.id) {
            this.$layer.msg('添加成功！')
            this.hideEditWindow()
            this.search()
          } else {
            this.$layer.msg('添加失败！')
          }
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('添加失败！')
        })
      }
    },
    // 删除
    async askDelete(id) {
      const url = '/message/' + id + '/'
      await this.$parent.showConfirm('确认删除此条数据吗?', () => {
        this.$http.put(url, {
          isdel: 1
        }).then((data) => {
          this.$layer.msg('删除成功！')
          this.search()
        }).catch((error) => {
          console.log(error)
          this.$layer.msg('删除失败！')
        })
      })
    },
    // 发布
    publish(id) {
      this.$parent.showConfirm('确定要发送吗？', () => {
        this.askRelease(id)
      })
    },
    // 发布
    async askRelease(id) {
      const url = '/message/' + id + '/'
      await this.$http.put(url, {
        status: 1,
        sendTime: this.getCurrentTime()
      }).then(async(data) => {
        await this.sendMessage(data.id)
        this.$layer.msg('发送成功！')
        this.$parent.getMessageCount()
        this.search()
      }).catch((error) => {
        console.log(error)
        this.$layer.msg('发送失败！')
      })
    },
    async sendMessage(id) {
      await this.$http.post('/message_send/', {
        id: id
      }).then((data) => {

      }).catch((error) => {
        console.log(error)
      })
    },
    // 获取当前时间
    getCurrentTime() {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      const hh = new Date().getHours()
      const mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
      const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
      _this.gettime = yy + '-' + mm + '-' + dd + 'T' + hh + ':' + mf + ':' + ss
      return _this.gettime
    },
    // 分页
    async pageCallback(data) {
      this.queryInfo.page = data
      await this.search()
    }
  },
  mounted() {
    this.search()
  }
}
</script>
<style lang="less" scoped>
textarea {
  min-height: 200px;
  resize: none;
}
#list .send {
  color: orange;
  text-decoration: underline;
}
</style>
